import { gql } from '@apollo/client';

export default gql`
  mutation deleteOperationFinance($_id: String) {
    deleteOperationFinance(_id: $_id) {
      ok
      message
      data
      error
    }
  }
`;
